import Vue from 'vue';
import TranslationService from '../../services/src/translate/translateService';

Vue.filter('translate', function(message, ...args) {
	return TranslationService.getString(message, ...args);
});



// WEBPACK FOOTER //
// ../common/filters/translateFilter/translateFilter.js